import React from "react";

import ChapterBreak from "@app/analytics/MeetingReport/components/ChapterBreak";
import useTranscriptStore from "@app/analytics/MeetingReport/stores/transcript";
import type { SessionChapter } from "@app/common/types";

const TranscriptChapterItem = ({ chapter }: { chapter: SessionChapter }) => {
  const seekChapter = useTranscriptStore((state) => state.seekChapter);

  return (
    <ChapterBreak
      {...chapter}
      onPageUp={seekChapter}
      onPageDown={seekChapter}
    />
  );
};

export default TranscriptChapterItem;
